// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Col, Table, Row, FormGroup, FormControl } from 'react-bootstrap'
import { MainSidebar } from '../components/mainsidebar'
import { SecSidebar } from '../components/secsidebar'
import { Message } from '../components/message'
import { Loading } from '../components/loading'
import config from '../config/config.json'
import { evalDateHour } from '../utils/enUtils.js'

export class Leaderboards extends Component {
    constructor(props) {
        super(props)

        this.getLeaderboards(this.props.env, config)

        this.state = {
            leaderboards: [],
            moduleFilter: 'All',
            scenarioFilter: 'All',
            searchString: '',
            filteredResults: [],
            loading: true
        }

        this.init = this.init.bind(this)
        this.filterWorker = this.filterWorker.bind(this)
        this.filterModule = this.filterModule.bind(this)
        this.filterScenario = this.filterScenario.bind(this)

        this.init()
    }

    init() {
        if (!window.sessionStorage.getItem('authToken')) {
            console.log("not logged in")
            this.props.router.push('/login')
        }
    }

    getLeaderboards(env, config) {
        fetch(config[env] + config.api.leaderboards.endpoint, {
            method: config.api.leaderboards.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.appData.authToken || window.sessionStorage.authToken
            }
        }).then((response) => response.json())
            .then((responseJson) => {
                let leaderboards = responseJson

                this.setState({
                    leaderboards: leaderboards,
                    loading: false
                })
            })
            .catch((error) => {
                console.error(error)
            })
    }

    filterWorker(e) {
        this.setState({
            searchString: e.target.value
        })
    }

    filterModule(e) {
        this.setState({
            moduleFilter: e.target.value
        })
    }

    filterScenario(e) {
        this.setState({
            scenarioFilter: e.target.value
        })
    }

    get displayLeaderboards() {
        if (this.state.loading) {
            return (
                <Loading />
            )
        }

        if (this.state.leaderboards.length === 0) {
            return (
                <Message text="No leaderboards found"/>
            )
        }

        return (
            <Table responsive bsClass="table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Module</th>
                        <th>Scenario</th>
                        <th>Score</th>
                        <th>Date</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className="filter-panel">
                        <td>
                            <form id="search">
                                <FormGroup controlId="formSearchString">
                                    <FormControl type="text" placeholder="Search Name" inputRef={ref => { this.searchInput = ref }} onChange={this.filterWorker} />
                                </FormGroup>
                            </form>
                        </td>
                        <td>
                            <form id="filterModule">
                                <FormGroup controlId="formModuleFilter">
                                    <FormControl componentClass="select" placeholder="select" inputRef={ref => { this.moduleInput = ref }} onChange={this.filterModule}>
                                        <option value="All">All</option>
                                        {this.loadModulesDisplay()}
                                    </FormControl>
                                </FormGroup>
                            </form>
                        </td>
                        <td>
                            <form id="filterScenario">
                                <FormGroup controlId="formScenarioFilter">
                                    <FormControl componentClass="select" placeholder="select" inputRef={ref => { this.scenarioInput = ref }} onChange={this.filterScenario}>
                                        <option value="All">All</option>
                                        {this.loadScenariosDisplay()}
                                    </FormControl>
                                </FormGroup>
                            </form>
                        </td>
                        <td></td>
                        <td></td>
                    </tr>
                    {this.displayLeaderboardsData}
                </tbody>
            </Table>
        )
    }

    get displayLeaderboardsData() {
        let filteredList = this.state.leaderboards.filter(leaderboardItem => {
            if (this.state.moduleFilter === "All") {
                if (this.state.scenarioFilter === "All") {
                    return true
                } else {
                    return (leaderboardItem.scenario_name === this.state.scenarioFilter)
                }
            }
            else {
                if (this.state.scenarioFilter === "All") {
                    return (this.state.moduleFilter === leaderboardItem.enabler_module_name)
                } else {
                    return (this.state.moduleFilter === leaderboardItem.enabler_module_name && leaderboardItem.scenario_name === this.state.scenarioFilter)
                }
            }
        })

        filteredList = filteredList.filter(leaderboardItem => {
            return ((leaderboardItem.first_name.toLowerCase()).indexOf(this.state.searchString.toLowerCase()) > -1)
        })

        filteredList.sort((a, b) => (a.score > b.score) ? -1 : 1)

        return filteredList.map((leaderboard, index) => {
            return (
                <tr key={index}>
                    <td>{leaderboard.first_name + " " + leaderboard.last_name}</td>
                    <td>{leaderboard.enabler_module_name}</td>
                    <td>{leaderboard.scenario_name}</td>
                    <td>{leaderboard.score}</td>
                    <td>{evalDateHour(leaderboard.created_at)}</td>
                </tr>
            )
        })
    }

    loadModulesDisplay() {
        const uniqueModules = [...new Set(this.state.leaderboards.map(leaderboard => leaderboard.enabler_module_name))]

        return uniqueModules.map((uniqueModule, index) => {
            return (
                <option key={index} value={uniqueModule}>{uniqueModule}</option>
            )
        })
    }

    loadScenariosDisplay() {
        const uniqueScenarios = [...new Set(this.state.leaderboards.map(leaderboard => leaderboard.scenario_name))]

        return uniqueScenarios.map((uniqueScenario, index) => {
            return (
                <option key={index} value={uniqueScenario}>{uniqueScenario}</option>
            )
        })
    }

    render() {
        return (
            <div className="leaderboards-container workforce-container page-container">
                <MainSidebar
                    profileType={this.props.appData.profileType}
                    logout={this.props.handleLoginStateChange}
                    profile={1}
                    appData={this.props.appData}
                />

                <SecSidebar
                    profileType={this.props.appData.profileType}
                    menuItemsKey={"workforce"}
                    profile={5}
                />

                <div className="main-body" >
                    <div className="summary-container">
                        <Row>
                            <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                                <div className="main-header">
                                    <h2 className="title">Leaderboards</h2>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <Row>
                        <Col xsOffset={1} xs={10} smOffset={1} sm={10} mdOffset={1} md={10}>
                            {this.displayLeaderboards}
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/leaderboards.js